<script>
	import { orden_por, orden_dir } from '../store.js';

	export let handler = () => console.log("Unhandled action")
	
	let orderBy = $orden_por+''
	let orderDir = $orden_dir+''

	let order_fields = [
		{field :"touched", label:"Predeterminado" },
		{field :"importe1", label:"Precio" },
		{field :"categoria", label:"Categoria" },
	]

	function aceptar(){
		orden_por.set(orderBy)
		orden_dir.set(orderDir)
		handler({response:0,view_dst:'catalogo'})
	}

	function cancelar(){
		handler({response:0,view_dst:'catalogo'})
	}


</script>

<div class="modal" on:click|self={ cancelar }>
	<div class="card responsive-margin">
		<div class="section responsive-padding">
				<label for="">Elija como ordenar</label><br>
				<div class="input-group v-center" style="display:flex;flex-wrap: nowrap; ;width:100%;">
					<select style="width:75%;" bind:value={orderBy}>
						{#each order_fields as item, index}
							<option value="{item.field}">{item.label}</option>
						{/each}
					</select>
					{#if orderDir==='asc'}
						<button on:click={()=>orderDir='desc'}>Mayor a Menor</button>
					{/if}
					{#if orderDir==='desc'}
						<button on:click={()=>orderDir='asc'}>Menor a Mayor</button>
					{/if}
				</div>
		</div>		
		<div class="section" style="text-align: right;">
			<button class="cancel" on:click={ cancelar }>Cancel</button>
			<button class="ok" on:click={ aceptar }>Ok</button>
		</div>
	</div>
</div>
